import CardDetails from "../card-details/card-details.component";
import Card from "../card/card.component";

const CardContent = () => {
  return (
    <div>
      <Card />
      <CardDetails />
    </div>
  );
};

export default CardContent;
